export const replaceCloudinaryUrlTokens = (url: string, tokens: Record<string, string>) => {
  if (!url) {
    return "";
  }
  try {
    let resultUrl = url;
    Object.keys(tokens).map(token => {
      while (resultUrl.indexOf(token) >= 0) {
        resultUrl = resultUrl.replace(token, tokens[`${token}`]);
      }
    });
    return resultUrl;
  } catch (e) {
    console.log("url", url);
    console.log(e);
    return "";
  }
};
